import { component } from 'picoapp';

export default component((node: HTMLElement) => {
  /**
   * DOM elems + vars
   */
  const toggles = [...node.querySelectorAll<HTMLElement>('[data-toggle]')];
  const contentWrappers: NodeListOf<HTMLElement> = node.querySelectorAll('[data-content]');
  const sizeGuideButton = document.querySelector('[data-sizeguide-button]');

  contentWrappers[0].style.maxHeight = `${contentWrappers[0].scrollHeight}px`;
  toggles[0].classList.remove('text-gray-400');
  toggles[0].classList.add('text-black');

  /**
   * Eventlisteners
   */
  toggles.forEach((toggle, index) => {
    const content: HTMLElement = contentWrappers[index];

    toggle.addEventListener('click', () => {
      toggles.forEach((toggleEL) => {
        toggleEL.classList.remove('text-black');
        toggleEL.classList.add('text-gray-400');
      });

      toggle.classList.remove('text-gray-400');
      toggle.classList.add('text-black');

      contentWrappers.forEach((contentWrapper: HTMLElement) => {
        contentWrapper.style.maxHeight = null;
      });

      content.style.maxHeight = `${contentWrappers[index].scrollHeight}px`;
    });
  });

  sizeGuideButton?.addEventListener('click', (e: Event) => {
    e.preventDefault();
    const id = sizeGuideButton.getAttribute('href').replace('#', '');
    const section: HTMLElement = toggles.find((toggle) => toggle.dataset.id === id);
    const scrollToPos = Number(node.offsetTop) - 100;

    toggles.forEach((toggleEL) => {
      toggleEL.classList.remove('text-black');
      toggleEL.classList.add('text-gray-400');
    });

    section.classList.remove('text-gray-400');
    section.classList.add('text-black');

    contentWrappers.forEach((contentWrapper: HTMLElement) => {
      contentWrapper.style.maxHeight = null;
    });
    const sizeGuideContent: HTMLElement = Array.from(contentWrappers).find((wrapper: HTMLElement) => wrapper.dataset.sizeguide === 'true');
    sizeGuideContent.style.maxHeight = `${sizeGuideContent.scrollHeight}px`;

    window.scrollTo({
      top: scrollToPos,
      left: 0,
      behavior: 'smooth',
    });
  });
});
